import MuiLink from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { StatusBadge } from '../../../../../components/atoms/StatusBadge';
import { useGetServiceById } from '../../../../../queries/service-query';

const cellSx = { fontSize: '12px', py: 0.75, px: 1.5 };

const formatDate = (dateStr: string | undefined): string => {
  if (!dateStr) return '-';
  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleDateString(undefined, { dateStyle: 'medium' });
};

export interface LinkedJobRowProps {
  serviceId: number;
  zebra: boolean;
}

export const LinkedJobRow: React.FC<LinkedJobRowProps> = ({ serviceId, zebra }) => {
  const { data: service, isLoading, isError } = useGetServiceById(serviceId);
  const statusName = service?.serviceStatus?.name ?? '';
  const serviceTypeName = service?.serviceType?.[0]?.name ?? service?.serviceTypeCode ?? '';
  const location = service?.mainLocation ?? service?.location ?? '';
  const updatedAt = service?.scheduledAt ?? service?.createdAt;

  return (
    <TableRow
      sx={{
        bgcolor: zebra ? 'v4.tableEven' : 'transparent',
        '&:hover': { bgcolor: 'v4.tableHover' },
      }}
    >
      <TableCell sx={cellSx}>
        <MuiLink
          component={RouterLink}
          to={`/services/${serviceId}`}
          sx={{ fontSize: '12px', fontWeight: 500, color: 'v4.accent' }}
          underline="hover"
        >
          {`JOB-${serviceId}`}
        </MuiLink>
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? (
          <Skeleton variant="rounded" width={70} height={18} />
        ) : isError || !statusName ? (
          '—'
        ) : (
          <StatusBadge status={statusName} size="small" />
        )}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={80} /> : serviceTypeName || '—'}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={100} /> : location || '—'}
      </TableCell>
      <TableCell sx={cellSx}>
        {isLoading ? <Skeleton variant="text" width={70} /> : formatDate(updatedAt)}
      </TableCell>
    </TableRow>
  );
};
